import React from "react";
import PropTypes from "prop-types";
import StartDateDropdown from "../users/components/careers/start_date_dropdown";
import EndDateDropdown from "../users/components/careers/end_date_dropdown";
import InvalidFeedback from "../common/invalid_feedback";

function ExperienceForm(props) {
  const { index, experience, onExperieceInputChange } = props;

  return (
    <React.Fragment>
      <div className='form-group row'>
        <label className='col-12 col-md-6 col-form-label required' htmlFor={`career-experiences-attributes-${index}-title`}>
          役職
        </label>
        <div className='col-12 col-md-6'>
          <input
            name='title'
            className={`form-control ${experience.errors.title ? "is-invalid" : ""}`}
            onChange={event => onExperieceInputChange(event, experience, null)}
            value={experience.title || ""}
            placeholder='CEO'
            required='required'
            type='text'
            id={`career-experiences-attributes-${index}-title`}
          />
          <InvalidFeedback errors={experience.errors.title} label='役職' />
        </div>
      </div>
      <div className='form-group row mb-0'>
        <label className='col-12 col-md-6 col-form-label required' htmlFor={`career-experiences-attributes-${index}-start-year`}>
          在籍期間
        </label>
        <div className='col-12 col-md-6 form-group row no-gutters'>
          <StartDateDropdown
            index={index}
            experience={experience}
            initialStartDate={experience.start_date || ""}
            onExperienceChange={onExperieceInputChange}
            key={"start_date_" + index}
          />
          {!experience.current && (
            <EndDateDropdown
              index={index}
              experience={experience}
              initialEndDate={experience.end_date || ""}
              onExperienceChange={onExperieceInputChange}
              key={"end_date_" + index}
            />
          )}
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-12 col-md-6 col-form-label' htmlFor={`career-experiences-attributes-${index}-description`}>
          業務内容
        </label>
        <div className='col-12 col-md-6'>
          <textarea
            name='description'
            className={`form-control ${experience.errors.description ? "is-invalid" : ""}`}
            onChange={event => onExperieceInputChange(event, experience, null)}
            value={experience.description || ""}
            rows='5'
            id={`career-experiences-attributes-${index}-description`}
          />
          <InvalidFeedback errors={experience.errors.description} label='業務内容' />
        </div>
      </div>
    </React.Fragment>
  );
}

ExperienceForm.propTypes = {
  index: PropTypes.number.isRequired,
  experience: PropTypes.shape({
    title: PropTypes.string.isRequired,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    description: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
  }).isRequired,
  onExperieceInputChange: PropTypes.func.isRequired
};

export default ExperienceForm;
